// extracted by mini-css-extract-plugin
module.exports = {"day-strokecolor":"#000","day-canvasbgcolor":"#fff","night-strokecolor":"rgba(255,255,255,0.5)","night-canvasbgcolor":"#131415"};